// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import RefreshRounded from '@mui/icons-material/RefreshRounded';

// material ui
import { Box, IconButton, Tooltip, Typography } from '@mui/material';

import { DateTime } from 'luxon';

const LatestRefreshFooter = ({ latestRefresh, onRefresh, isUpdating }) => {
  const { t } = useTranslation('dashboards-common');
  const formatTimestamp = (ts) => {
    if (ts === null || ts === undefined || ts === '') return '—';
    try {
      let dt;
      if (typeof ts === 'number') dt = DateTime.fromMillis(ts);
      else dt = DateTime.fromISO(String(ts));
      if (!dt.isValid) dt = DateTime.fromJSDate(new Date(ts));
      return dt.setLocale('da-dk').toLocaleString(DateTime.DATETIME_MED);
    } catch (e) {
      return String(ts);
    }
  };
  if (isUpdating) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {t('footer.updating')}
        </Typography>
      </Box>
    );
  }
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography variant="body2" color="text.secondary">
        {t('footer.latestRefresh', { date: formatTimestamp(latestRefresh) })}
      </Typography>

      {!isUpdating && typeof onRefresh === 'function' && (
        <Tooltip title={t('footer.refresh')}>
          <IconButton size="small" onClick={onRefresh} aria-label="refresh">
            <RefreshRounded fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default LatestRefreshFooter;
